module.exports = __webpack_public_path__ + "static/media/arrow-right.4925ef0f.svg";